import React, { useCallback, useEffect, useState, memo } from 'react';

import { Input } from './Input';
import * as T from './interfaces';

export const Container = memo(
  ({
    defaultValue = '',
    id,
    onChange,
    mask,
    onBlur,
    onFocus,
    ...rest
  }: T.IInput) => {
    const [value, setValue] = useState(defaultValue);
    const [filled, setFilled] = useState(defaultValue.length > 0);
    const [isFocused, setIsFocused] = useState(false);

    const toggleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = mask
          ? mask(e.currentTarget.value)
          : e.currentTarget.value;
        setValue(newValue);
        setFilled(!!newValue);
        !!onChange && onChange(newValue);
      },
      [onChange, setFilled, setValue, mask],
    );

    const toggleFocus = useCallback(() => {
      setIsFocused(true);
      !!onFocus && onFocus();
    }, [setIsFocused, onFocus]);

    const toggleBlur = useCallback(() => {
      setIsFocused(false);
      !!onBlur && onBlur();
    }, [onBlur, setIsFocused]);

    const setDefaultValue = useCallback(() => {
      const newValue = mask ? mask(defaultValue) : defaultValue;
      setValue(newValue);
      setFilled(!!newValue);
      !!onChange && onChange(newValue);
    }, [defaultValue, setValue, onChange, setFilled, mask]);

    useEffect(() => {
      setDefaultValue();
    }, [setDefaultValue]);

    const Ids = {
      wrapper: `containerInput@${id}`,
      iconSearch: `searchInput@${id}`,
      input: `input@${id}`,
      icon: `iconInput@${id}`,
      load: `loadInput@${id}`,
      message: `messageInput@${id}`,
    };

    return (
      <Input
        ids={Ids}
        value={value}
        onChange={toggleChange}
        onBlur={toggleBlur}
        onFocus={toggleFocus}
        isFilled={filled}
        focused={isFocused}
        {...rest}
      />
    );
  },
);
